import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppGlobalData } from '../core/appglobaldata';
import { UISupplierContext } from '../models/internal/uisuppliercontext';
import { SummaryForSupplierDTO } from '../models/summary-for-supplier-dto';
import { SummaryForPEDTO } from '../models/summary-for-pe-dto';

@Injectable({
    providedIn: 'root',
})

export class AppGlobalDataService {
    private currentSupplierCodeSource = new BehaviorSubject<string>(null);
    private loginAsSource = new BehaviorSubject<string>(null);
    private appGlobalDataSource = new BehaviorSubject<AppGlobalData>(null);
    // private UserIdSource = new BehaviorSubject<number>(null);
    // private SupplierIdSource = new BehaviorSubject<number>(null);
    private UserDisplayNameSource = new BehaviorSubject<string>(null);
    private IsSupplierSource = new BehaviorSubject<boolean>(null);
    private IsEmployeeSource = new BehaviorSubject<string>(null);
    private IsAdminSource = new BehaviorSubject<string>(null);
    private UISupplierContextsSource = new BehaviorSubject<UISupplierContext[]>(null);
    private UnreadMessageCountSource = new BehaviorSubject<number>(null);
    private menuSupplierBadges = new Subject<SummaryForSupplierDTO>();
    private menuEngineerBadges = new Subject<SummaryForPEDTO>();


    // appGlobalData = this.appGlobalDataSource.asObservable();
    // public appGlobalData: AppGlobalData = new AppGlobalData();
    // UserId = this.UserIdSource.asObservable();
    // SupplierId = this.SupplierIdSource.asObservable();
    currentSupplierCode  = this.currentSupplierCodeSource.asObservable();
    loginAs  = this.loginAsSource.asObservable();
    UserDisplayName = this.UserDisplayNameSource.asObservable();
    IsSupplier = this.IsSupplierSource.asObservable();
    IsEmployee = this.IsEmployeeSource.asObservable();
    IsAdmin = this.IsAdminSource.asObservable();
    UISupplierContexts = this.UISupplierContextsSource.asObservable();
    UnreadMessageCount = this.UnreadMessageCountSource.asObservable();
    menuSupplierBadges$ = this.menuSupplierBadges.asObservable();
    menuEngineerBadges$ = this.menuEngineerBadges.asObservable();

    constructor() {}

    RefreshcurrentSupplierCode(code: string) {
        this.currentSupplierCodeSource.next(code);
    }

    RefreshloginAsSource(code: string) {
        this.loginAsSource.next(code);
    }

    RefreshUserDisplayName(value: string) {
        this.UserDisplayNameSource.next(value);
    }
    RefreshIsSupplier(value: boolean) {
        this.IsSupplierSource.next(value);
    }
    RefreshIsEmployee(value: string) {
        this.IsEmployeeSource.next(value);
    }
    RefreshIsAdmin(value: string) {
        this.IsAdminSource.next(value);
    }
    RefreshUISupplierContexts(value: UISupplierContext[]) {
        this.UISupplierContextsSource.next(value);
    }
    RefreshUnreadMessageCount(value: number) {
        this.UnreadMessageCountSource.next(value);
    }
    updateMenuSupplierBadges(value: SummaryForSupplierDTO) {
        this.menuSupplierBadges.next(value);
    }

    updateMenuEngineerBadges(value: SummaryForPEDTO) {
        this.menuEngineerBadges.next(value);
    }

    // RefreshAppGlobalData(propertyName: string, value: any) {
    //     // debugger;
    //     // const newAppGlobalData: AppGlobalData = cloneDeep(this.appGlobalData);
    //     this.appGlobalData[propertyName] = value;
    //     this.appGlobalDataSource.next(this.appGlobalData)
    // }

    // getValue(propertyName: string)
    // {
    //     return this.appGlobalData[propertyName];
    // }
}
